import { Component, OnInit, AfterViewInit, ViewEncapsulation, ViewChild, AfterContentInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Table, TableModule } from 'primeng/table';

import { ROWS_PER_PAGE_OPTIONS, AuthService, CommonService, CacheService, ToolTipService } from '../../../common/service';
import { SensorWarrantyCheck } from '../../../common/model';
import { Permission, tooltip } from '../../../common/enum';
import { FilterService, PrimeTemplate } from 'primeng/api';

import { TooltipModule } from 'primeng/tooltip';
import { FormsModule } from '@angular/forms';
import { NgIf, NgFor, NgStyle, NgSwitch, NgSwitchCase, NgSwitchDefault, NgClass, DecimalPipe, DatePipe } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputTextModule } from 'primeng/inputtext';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { Select } from 'primeng/select';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'sensor-warranty-check-grid',
  templateUrl: './sensor-warranty-check-grid.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [TableModule, PrimeTemplate, TooltipModule, FormsModule, NgIf,
    ButtonDirective, MultiSelectModule, NgFor, NgStyle, NgSwitch, NgSwitchCase, InputTextModule, CheckboxModule,
    NgSwitchDefault, NgClass, DecimalPipe, DatePipe, Select, DatePickerModule]
})
export class SensorWarrantyCheckGridComponent implements OnInit, AfterViewInit {
  @ViewChild('_table') private _table: Table;
  Permission = Permission;
  globalSearch: string;
  rows: SensorWarrantyCheck[];
  _rows: SensorWarrantyCheck[];
  cols: any;
  defaultCols: any[] = [];
  selectedCols: any;
  rowsPerPage: any;
  rowsPerPageOptions = [...ROWS_PER_PAGE_OPTIONS];
  isSaving = false;
  tt: any;
  installation_date: Date;
  expiry_date: Date;
  last_communicated: Date[];
  failure_date: Date[];
  stabilisation_start: Date[];
  stabilisation_end: Date[];
  rebasing_start: Date[];
  amended_date: Date[];
  created_date: Date[];
  searchFailures = new SensorWarrantyCheck;

  constructor(
    private route: ActivatedRoute,
    @Inject(AuthService) public authService: AuthService,
    @Inject(CommonService) public commonService: CommonService,
    @Inject(CacheService) public cacheService: CacheService,
    @Inject(ToolTipService) public toolTipService: ToolTipService,
    private filterService: FilterService) { }

  ngOnInit() {
    this.rows = this.route.snapshot.data['getSensorWarrantyCheck'];
    this.rowsPerPage = this.cacheService.GetLocal(`SensorWarrantyCheckGrid-RowsPerPage`, 10);

    this.cols = this.getColConfig();
    this.selectedCols = this.cacheService.GetLocal(`SensorWarrantyCheckGrid-SelectedCols`, this.cols.filter(c => c.isHidden === false));
    this.tt = this.getToolTip();
    this._rows = JSON.parse(JSON.stringify(this.rows));
  }

  exportCSV() {
    const header = new Array;
    for (let index = 0; index < this.selectedCols.length; index++) {
      header.push(this.selectedCols[index].header);
    }
    this.commonService.exportCSV(this.rows, this.selectedCols, header, 'sensor-warranty-export', SensorWarrantyCheck);
  }

  ngAfterViewInit() {
    const _self = this;
    this.filterService.filters['installationDateRangeFilter'] = (value, filter): boolean => {
      if (this.commonService.isNullOrUndefined(_self.installation_date)) { return true; }
      // get the from/start value
      const installStartTime = _self.installation_date[0].getTime();
      let installEndTime;
      // the to/end value might not be set
      // use the from/start date and add 1 day
      // or the to/end date and add 1 day
      if (_self.installation_date[1]) {
        installEndTime = _self.installation_date[1].getTime() + 86400000;
      } else {
        installEndTime = installStartTime + 86400000;
      }
      // compare it to the actual values
      return new Date(value).getTime() >= installStartTime && new Date(value).getTime() <= installEndTime;
    };

    this.filterService.filters['lastCommunicatedRangeFilter'] = (value, filter): boolean => {
      if (this.commonService.isNullOrUndefined(_self.last_communicated)) { return true; }
      // get the from/start value
      const lastCommunicatedStartTime = _self.last_communicated[0].getTime();
      let lastCommunicatedEndTime;
      // the to/end value might not be set
      // use the from/start date and add 1 day
      // or the to/end date and add 1 day
      if (_self.last_communicated[1]) {
        lastCommunicatedEndTime = _self.last_communicated[1].getTime() + 86400000;
      } else {
        lastCommunicatedEndTime = lastCommunicatedStartTime + 86400000;
      }

      // compare it to the actual values
      return new Date(value).getTime() >= lastCommunicatedStartTime && new Date(value).getTime() <= lastCommunicatedEndTime;
    };

    this.filterService.filters['expiryDateRangeFilter'] = (value, filter): boolean => {
      if (this.commonService.isNullOrUndefined(_self.expiry_date)) { return true; }
      // get the from/start value
      const expiryStartTime = _self.expiry_date[0].getTime();
      let expiryEndTime;
      // the to/end value might not be set
      // use the from/start date and add 1 day
      // or the to/end date and add 1 day
      if (_self.expiry_date[1]) {
        expiryEndTime = _self.expiry_date[1].getTime() + 86400000;
      } else {
        expiryEndTime = expiryStartTime + 86400000;
      }

      // compare it to the actual values
      return new Date(value).getTime() >= expiryStartTime && new Date(value).getTime() <= expiryEndTime;
    };

    this.filterService.filters['failureDateRangeFilter'] = (value, filter): boolean => {
      if (this.commonService.isNullOrUndefined(_self.failure_date)) { return true; }
      // get the from/start value

      const failureStartTime = _self.failure_date[0].getTime();
      let failureEndTime;
      // the to/end value might not be set
      // use the from/start date and add 1 day
      // or the to/end date and add 1 day
      if (_self.failure_date[1]) {
        failureEndTime = _self.failure_date[1].getTime() + 86400000;
      } else {
        failureEndTime = failureStartTime + 86400000;
      }
      // compare it to the actual values
      return new Date(value).getTime() >= failureStartTime && new Date(value).getTime() <= failureEndTime;
    };

    this.filterService.filters['stabilisation_startDateRangeFilter'] = (value, filter): boolean => {
      if (this.commonService.isNullOrUndefined(_self.stabilisation_start)) { return true; }
      // get the from/start value
      const stabilisationStartStartTime = _self.stabilisation_start[0].getTime();
      let stabilisationStartEndTime;
      // the to/end value might not be set
      // use the from/start date and add 1 day
      // or the to/end date and add 1 day
      if (_self.stabilisation_start[1]) {
        stabilisationStartEndTime = _self.stabilisation_start[1].getTime() + 86400000;
      } else {
        stabilisationStartEndTime = stabilisationStartStartTime + 86400000;
      }

      // compare it to the actual values
      return new Date(value).getTime() >= stabilisationStartStartTime && new Date(value).getTime() <= stabilisationStartEndTime;
    };

    this.filterService.filters['stabilisation_endDateRangeFilter'] = (value, filter): boolean => {
      if (this.commonService.isNullOrUndefined(_self.stabilisation_end)) { return true; }
      // get the from/start value
      const stabilisationEndStartTime = _self.stabilisation_end[0].getTime();
      let stabilisationEndEndTime;
      // the to/end value might not be set
      // use the from/start date and add 1 day
      // or the to/end date and add 1 day
      if (_self.stabilisation_end[1]) {
        stabilisationEndEndTime = _self.stabilisation_end[1].getTime() + 86400000;
      } else {
        stabilisationEndEndTime = stabilisationEndStartTime + 86400000;
      }

      // compare it to the actual values
      return new Date(value).getTime() >= stabilisationEndStartTime && new Date(value).getTime() <= stabilisationEndEndTime;
    };

    this.filterService.filters['rebasing_startDateRangeFilter'] = (value, filter): boolean => {
      if (this.commonService.isNullOrUndefined(_self.rebasing_start)) { return true; }
      // get the from/start value
      const rebasingStartStartTime = _self.rebasing_start[0].getTime();
      let rebasingStartEndTime;
      // the to/end value might not be set
      // use the from/start date and add 1 day
      // or the to/end date and add 1 day
      if (_self.rebasing_start[1]) {
        rebasingStartEndTime = _self.rebasing_start[1].getTime() + 86400000;
      } else {
        rebasingStartEndTime = rebasingStartStartTime + 86400000;
      }

      // compare it to the actual values
      return new Date(value).getTime() >= rebasingStartStartTime && new Date(value).getTime() <= rebasingStartEndTime;
    };

    this.filterService.filters['amendedDateRangeFilter'] = (value, filter): boolean => {
      if (this.commonService.isNullOrUndefined(_self.amended_date)) { return true; }
      // get the from/start value
      const amendedStartTime = _self.amended_date[0].getTime();
      let amendedEndTime;
      // the to/end value might not be set
      // use the from/start date and add 1 day
      // or the to/end date and add 1 day
      if (_self.amended_date[1]) {
        amendedEndTime = _self.amended_date[1].getTime() + 86400000;
      } else {
        amendedEndTime = amendedStartTime + 86400000;
      }
      // compare it to the actual values
      return new Date(value).getTime() >= amendedStartTime && new Date(value).getTime() <= amendedEndTime;
    };

    this.filterService.filters['createdDateRangeFilter'] = (value, filter): boolean => {
      if (this.commonService.isNullOrUndefined(_self.created_date)) { return true; }
      // get the from/start value
      const createdStartTime = _self.created_date[0].getTime();
      let createdEndTime;
      // the to/end value might not be set
      // use the from/start date and add 1 day
      // or the to/end date and add 1 day
      if (_self.created_date[1]) {
        createdEndTime = _self.created_date[1].getTime() + 86400000;
      } else {
        createdEndTime = createdStartTime + 86400000;
      }

      // compare it to the actual values
      return new Date(value).getTime() >= createdStartTime && new Date(value).getTime() <= createdEndTime;
    };

    if (!this.commonService.isNullOrUndefined(this._table)) {
      if (localStorage.getItem(this._table.stateKey)) {
        const table = JSON.parse(localStorage.getItem(this._table.stateKey));
        table.filters = {};
        localStorage.setItem(this._table.stateKey, JSON.stringify(table));
        this._table.restoreState();
      }
    }
  }

  clearCols() {
    this.cols = this.getColConfig();
    this.cacheService.SetLocal(`SensorWarrantyCheckGrid-SelectedCols`, this.cols.filter(c => c.isHidden === false));
    this.selectedCols = this.cacheService.GetLocal(`SensorWarrantyCheckGrid-SelectedCols`, this.cols.filter(c => c.isHidden === false));
    if (!this.commonService.isNullOrUndefined(this._table)) {
      this._table = this.commonService.resetTableCols(this._table, this.selectedCols, false, false);
    }

  }

  clearFilter(filter) {
    switch (filter) {
      case 'installation_date': {
        this.installation_date = null;
        break;
      }
      case 'expiry_date': {
        this.expiry_date = null;
        break;
      }
      case 'last_communicated': {
        this.last_communicated = null;
        break;
      }
      case 'failure_date': {
        this.failure_date = null;
        break;
      }
      case 'stabilisation_start': {
        this.stabilisation_start = null;
        break;
      }
      case 'stabilisation_end': {
        this.stabilisation_end = null;
        break;
      }
      case 'rebasing_start': {
        this.rebasing_start = null;
        break;
      }
      case 'amended_date': {
        this.amended_date = null;
        break;
      }
      case 'created_date': {
        this.created_date = null;
        break;
      }
    }
    this._table.filter(null, filter, 'in');
  }

  getColConfig() {
    if (this.authService.isAdministrator()) {
      return [
        { field: 'pod_serial_number', header: 'Pod Serial', isHidden: false, isReadonly: true, datatype: 'number', filter: this.commonService.getFilter(this.rows, 'pod_serial_number', false), colWidth: '90px' },
        { field: 'part_number', header: 'Part Number', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'part_number', false), colWidth: '110px' },
        { field: 'project_name', header: 'Project', isHidden: true, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'project_name', false), colWidth: '200px' },
        { field: 'location_name', header: 'Pod Location', isHidden: true, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'location_name', false), colWidth: '175px' },
        { field: 'owner_name', header: 'Owner', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'owner_name', false), colWidth: '175px' },
        { field: 'distributor', header: 'Distributor', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'distributor', false), colWidth: '175px' },
        { field: 'sales_type', header: 'Sale Type', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'sales_type', false), colWidth: '70px' },
        { field: 'sensor_serial_number', header: 'Sensor Serial', isHidden: false, isReadonly: true, datatype: 'text', colWidth: '145px' },
        { field: 'sensor_type', header: 'Sensor Type', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'sensor_type', false), colWidth: '70px' },
        { field: 'sensor_position', header: 'Sensor Position', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'sensor_position', false), colWidth: '70px' },
        { field: 'sensor_status', header: 'Sensor Status', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'sensor_status', false), colWidth: '70px' },
        { field: 'installation_date', header: 'Date Fitted', isHidden: false, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'age_in_months', header: 'Age in months', isHidden: false, isReadonly: true, datatype: 'number', colWidth: '70px' },
        { field: 'expiry_date', header: 'Warranty Expiry', isHidden: false, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'last_communicated', header: 'Last Communicated', isHidden: false, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'failure_date', header: 'Failure Date', isHidden: false, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'stabilisation_start', header: 'Last Stabilised', isHidden: true, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'stabilisation_end', header: 'Stabilise end', isHidden: true, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'rebasing_start', header: 'Last Rebase', isHidden: true, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'amended_date', header: 'Last amended', isHidden: true, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'amended_by', header: 'Last changed by', isHidden: true, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'amended_by', false), colWidth: '100px' },
        { field: 'created_date', header: 'Date recorded', isHidden: true, isReadonly: true, datatype: 'Date', colWidth: '90px' }
      ];
    } else {
      return [
        { field: 'pod_serial_number', header: 'Pod Serial', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'pod_serial_number', false), colWidth: '92px' },
        { field: 'part_number', header: 'Part Number', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'part_number', false), colWidth: '119px' },
        { field: 'project_name', header: 'Project', isHidden: true, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'project_name', false), colWidth: '200px' },
        { field: 'location_name', header: 'Pod Location', isHidden: true, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'location_name', false), colWidth: '200px' },
        { field: 'owner_name', header: 'Owner', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'owner_name', false), colWidth: '494px' },
        { field: 'distributor', header: 'Distributor', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'distributor', false), colWidth: '574px' },
        { field: 'sales_type', header: 'Sale Type', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'sales_type', false), colWidth: '130px' },
        { field: 'sensor_serial_number', header: 'Sensor Serial', isHidden: false, isReadonly: true, datatype: 'text', colWidth: '145px' },
        { field: 'sensor_type', header: 'Sensor Type', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'sensor_type', false), colWidth: '120px' },
        { field: 'sensor_position', header: 'Sensor Position', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'sensor_position', false), colWidth: '120px' },
        { field: 'sensor_status', header: 'Sensor Status', isHidden: false, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'sensor_status', false), colWidth: '120px' },
        { field: 'installation_date', header: 'Date Fitted', isHidden: false, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'age_in_months', header: 'Age in months', isHidden: false, isReadonly: true, datatype: 'number', colWidth: '100px' },
        { field: 'expiry_date', header: 'Warranty Expiry', isHidden: false, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'last_communicated', header: 'Last Communicated', isHidden: false, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'failure_date', header: 'Failure Date', isHidden: false, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'stabilisation_start', header: 'Last Stabilised', isHidden: true, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'stabilisation_end', header: 'Stabilise end', isHidden: true, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'rebasing_start', header: 'Last Rebase', isHidden: true, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'amended_date', header: 'Last amended', isHidden: true, isReadonly: true, datatype: 'Date', colWidth: '110px' },
        { field: 'amended_by', header: 'Last changed by', isHidden: true, isReadonly: true, datatype: 'string', filter: this.commonService.getFilter(this.rows, 'amended_by', false), colWidth: '200px' },
        { field: 'created_date', header: 'Date recorded', isHidden: true, isReadonly: true, datatype: 'Date', colWidth: '110px' }
      ];
    }
  }

  getToolTip() {
    return ({
      pod_serial: this.toolTipService.filterToolTips(tooltip.serial_number),
      part_number: this.toolTipService.filterToolTips(tooltip.partNo),
      owner_name: this.toolTipService.filterToolTips(tooltip.owner_name),
      distributor: this.toolTipService.filterToolTips(tooltip.customer_name),
      sales_type: this.toolTipService.filterToolTips(tooltip.sale_type_name),
      sensor_serial: this.toolTipService.filterToolTips(tooltip.sensorSerial),
      sensor_type: this.toolTipService.filterToolTips(tooltip.sensor_Type),
      sensor_position: this.toolTipService.filterToolTips(tooltip.sensor_position),
      sensor_status: this.toolTipService.filterToolTips(tooltip.sensor_Status),
      date_fitted: this.toolTipService.filterToolTips(tooltip.date_fitted),
      age_in_months: this.toolTipService.filterToolTips(tooltip.age_in_months),
      warranty: this.toolTipService.filterToolTips(tooltip.warranty),
      last_communicated: this.toolTipService.filterToolTips(tooltip.last_communicated),
      failure_date: this.toolTipService.filterToolTips(tooltip.failure_date),
      project_name: this.toolTipService.filterToolTips(tooltip.project_name),
      pod_location: this.toolTipService.filterToolTips(tooltip.locationName),
      date_recorded: this.toolTipService.filterToolTips(tooltip.date_recorded),
      last_changed: this.toolTipService.filterToolTips(tooltip.last_changed),
      last_ammended: this.toolTipService.filterToolTips(tooltip.last_ammended),
      last_rebase: this.toolTipService.filterToolTips(tooltip.last_rebase),
      stabilise_end: this.toolTipService.filterToolTips(tooltip.stabilise_end),
      last_stabilised: this.toolTipService.filterToolTips(tooltip.last_stabilised),
      global_Search: this.toolTipService.filterToolTips(tooltip.global_Search),
      row_Select: this.toolTipService.filterToolTips(tooltip.rowsSelected),
      rows_Total: this.toolTipService.filterToolTips(tooltip.rowTotal),
      rows_Availible: this.toolTipService.filterToolTips(tooltip.rowsAvailible),
      export: this.toolTipService.filterToolTips(tooltip.export_All),
      columns: this.toolTipService.filterToolTips(tooltip.columnsSelected),
      refreshColumns: this.toolTipService.filterToolTips(tooltip.resetColumn)
    });
  }

  reset() {
    if (!this.commonService.isNullOrUndefined(this._table)) {
      if (localStorage.getItem(this._table.stateKey)) {
        this._table = this.commonService.resetTableFilters(this._table)
      }
    }
    this.searchFailures = new SensorWarrantyCheck;
    this.installation_date = null;
    this.expiry_date = null;
    this.last_communicated = null;
    this.failure_date = null;
    this.stabilisation_start = null;
    this.stabilisation_end = null;
    this.rebasing_start = null;
    this.amended_date = null;
    this.created_date = null;
  }

  setPreferences() {
    this.cacheService.SetLocal(`SensorWarrantyCheckGrid-RowsPerPage`, this.rowsPerPage);
    this.cacheService.SetLocal(`SensorWarrantyCheckGrid-SelectedCols`, this.selectedCols);
    this._table = this.commonService.resetTableCols(this._table, this.selectedCols, false, false);

  }

  has(requiredPermissions: Permission | Permission[]) {
    return this.authService.hasPermission(requiredPermissions);
  }
}
